
import bg from '../assets/bg.png';
import chef from '../assets/chef.png';
import G from '../assets/G.png';
import fcb1 from '../assets/fcb1.png';
import fcb2 from '../assets/fcb2.png';
import fcb3 from '../assets/fcb3.png';
import fcb4 from '../assets/fcb4.png';
import knife from '../assets/knife.png';
import logo from '../assets/logo.png';
import menu from '../assets/menu.png';
import overlaybg from '../assets/overlaybg.png';
import welcome from '../assets/welcome.png';
import location from '../assets/location.png';
import laurels from '../assets/laurels.png';
import award from '../assets/award.png';
import quote from '../assets/quote.png';
import regal from '../assets/regal.png';

export default {
  bg,
  chef,
  G,
  fcb1,
  fcb2,
  fcb3,
  fcb4,
  knife,
  logo,
  menu,
  overlaybg,
  welcome,
  location,
  laurels,
  award,
  quote,
  regal,
};